// extracted by mini-css-extract-plugin
export default {"qnaTip":"QnaTip_qnaTip__UZsxb","qnaTipText":"QnaTip_qnaTipText__r-dnK","btnInquiry":"QnaTip_btnInquiry__GfxLJ"};